<template>
  <el-dialog
      v-if="dialogSwitch"
      :visible.sync="dialogSwitch"
      :close-on-click-modal="false"
      class="dialogBox"
      width="450px"
      @close="dialogSwitch = false"
      :modal-append-to-body="false">
    <div class="title" slot="title">{{type === 'reject' ? '创建失败原因' : '冻结原因'}}</div>
    <div class="info">
      <div class="imgBox">
        <el-image class="screenshot" :src="appDetail.appIcon">
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
      </div>
      <div class="infoBox">
        <p style="font-weight: bold">{{ appDetail.appName }}</p>
        <p>包名：{{ appDetail.appPackage }}</p>
      </div>
    </div>
    <div class="reason"><span style="font-weight: 400;">原因：</span>{{ type === 'freeze' ? appDetail.reason : appDetail.remark }} </div>

  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogSwitch: false,
      type: '', // freeze冻结、reject申请驳回
      appDetail: {}
    };
  },
  created() {

  },
  methods: {
    show(id, type) {
      this.type = type;
      this.dialogSwitch = true;
      this.queryFreezeReason(id)
    },
    //获取应用信息
    queryFreezeReason(id) {
      this.$apis.consoleSever.queryDetail({id}).then(res => {
        if (res.code == 0) {
          this.appDetail = res.data;
        }
      })
    },
  },
};
</script>

<style scoped lang="scss">
.dialogBox {
  /deep/ .el-dialog {
    border-radius: 10px;
    .el-dialog__body {
      padding: 15px 32px;
    }
  }
  .title {
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 10px;
    border-bottom: 1px solid #ccc;
  }

  .info {
    display: flex;
    line-height: 25px;

    .imgBox {
      margin-right: 10px;
      width: 70px;
      height: 70px;
      //border: 1px solid #000;
      //border-radius: 2px;
    }
    .infoBox {
      flex: 1;
      p {
        margin-top: 5px;
      }
    }
  }
  .reason {
    //font-weight: 700;
    margin: 25px 0 10px;
    font-size: 18px;
  }
}

</style>
